import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { CommonVariablesService } from '../../common-variables.service';

@Component({
  selector: 'app-bulkdeclarationreport',
  templateUrl: './bulkdeclarationreport.component.html',
})
export class BulkdeclarationreportComponent implements OnInit {
  bulkDeclarationReportForm: FormGroup;
  systemDate: any;
  getFromDate: any;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  displayBulkDeckarationReport: any = [];
  displayFinalBulkDeckarationReport: any = [];
  submitted = false;
  getsystemDate: any;
  fromDate: any;
  toDate: any;
  submitFromDate: any;
  submitToDate: any;
  // bulk declaration report changes
  getPolicyType: any;
  getBulkDeclarationType: any;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
	window.localStorage.setItem('pageName','');
    $('#divBulkDeclarationReportDataTable').hide();
    $('#btnBulkDeclarationReportExcelDownload').hide();
    this.bulkDeclarationReportForm = this.formBuilder.group({
      selectFromDate: ['', Validators.required],
      selectToDate: ['', Validators.required],
      // bulk declaration report changes
      policyType: ['', Validators.required],
      bulkDeclarationType: ['', Validators.required]
    });
    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };
    this.getsystemDate = new Date();
    let getDate = new Date(this.getsystemDate);
    getDate.setMonth(getDate.getMonth() - 1);
    this.getFromDate = getDate;
    this.systemDate = this.datePipe.transform(this.getsystemDate, 'yyyy-MM-dd');
  }
  get f() { return this.bulkDeclarationReportForm.controls; }

  // bulk declaration report changes
  checkValueBulk(evt) {
    // console.log("CEHCK EVENT",evt?.target?.value);
    let val = evt?.target?.value;
    if (val=="Bulk - Monthly,Bulk - Quarterly,Bulk - Yearly,Bulk - Half Yearly,Bulk - Fortnightly") {
      document.getElementById("optionAllPolicy").setAttribute("disabled","true");
    }else{
      document.getElementById("optionAllPolicy").removeAttribute("disabled");
    }
  }

  // bulk declaration report changes
  checkValuePolicy(evt){
    // console.log("CEHCK EVENT",evt?.target?.value);
    let val = evt?.target?.value;
    if (val=="STOP,MOP") {
      // console.log("ENyter111");
      document.getElementById("optionAll").setAttribute("disabled","true");
    }else{
      // console.log("ENyter2222222");
      document.getElementById("optionAll").removeAttribute("disabled");
    } 
  }

  /*
  * Created By : Keerthana
  * Description : This function will submit the data.
  *********************************************/
  async submitDate() {
    if (this.bulkDeclarationReportForm.invalid) {
      this.submitted = true;
      return;
    }
    else {
      this.fromDate = this.datePipe.transform(this.bulkDeclarationReportForm.value.selectFromDate);
      this.toDate = this.datePipe.transform(this.bulkDeclarationReportForm.value.selectToDate);
      // bulk declaration report changes
      this.getPolicyType = (this.bulkDeclarationReportForm.value.policyType);
      this.getBulkDeclarationType = (this.bulkDeclarationReportForm.value.bulkDeclarationType);

      if (new Date(this.toDate) < new Date(this.fromDate)) {
        this.commonService.errorsmsg("From date should be less than to date", "Error");
      }
      else {
        this.spinner.show();
        $('#searchClientUserId,#searchPolicyNo,#searchPolicyType,#searchPolicyExpirtDate,#searchBranchLocation,#searchInsuredName,#searchProducerName,#searchProducerEmailId,#searchDeclarationFrequency,#searchDeclarationPendingFor,#lastRemindSentOn').val('');
        let table = $('#bulkDeclarationReportDataTable').DataTable();
        table.destroy();
        this.submitFromDate = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
        this.submitToDate = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
        this.displayBulkDeckarationReport = [];
        this.displayFinalBulkDeckarationReport = [];

        // bulk declaration report changes
        let fetchUrl = this.commonVariablesService.baseURL + 'api/v1/marine_report/fetch_bulk_declaration?from_date=' + this.submitFromDate + '&to_date=' + this.submitToDate + '&policy_type='+ this.getPolicyType + '&bulk_declaration_type=' + this.getBulkDeclarationType;

        let responseData = await this.commonService.httpGetMethod(fetchUrl, '', true, '', 'Bulk Declaration Report');
        var tblData: any = [];

        let policyNoArray = '';
        if (responseData.status == 0) {
          for (let count = 0; count < responseData.data.length; count++) {
           this.displayFinalBulkDeckarationReport.push(responseData.data[count]);
          }
          /*if (tblData.length > 0) {
            for (var i = 0; i < tblData.length; i++) {
              if (i < tblData.length - 1) {
                policyNoArray += tblData[i].policy_no + ",";
              }
              else {
                policyNoArray += tblData[i].policy_no;
              }
            }
            if (policyNoArray != '') {
              // let param = new HttpParams()
                // .set('policy_no', policyNoArray)
              let param = {
                policy_no: policyNoArray.toString()
              }

              let fetchCustomerIdUrl = this.commonVariablesService.baseURL + 'api/v1/marine_report/bulkdeclaration';
              let fetchCustomerIdData = await this.commonService.httpPostMethod(fetchCustomerIdUrl, param, '', true, 'Bulk Declaration Report');
              fetchCustomerIdData = fetchCustomerIdData.body;
              //let fetchTableDateValueURL = this.commonVariablesService.baseURL + 'api/v1/marine_report/fetch_bulk_declaration/mail_log'
              //let fetchTableDateValue = await this.commonService.httpGetMethod(fetchTableDateValueURL, '', true, '', 'Bulk Declaration Report');
              if (fetchCustomerIdData.status == 0) {
                if (fetchCustomerIdData.data.length > 0) {

                  for (var idx = 0; idx < tblData.length; idx++) {
                    for (var j = 0; j < fetchCustomerIdData.data.length; j++) {
                      if (tblData[idx].policy_no == fetchCustomerIdData.data[j].policy_number) {
                        tblData[idx].customer_id = fetchCustomerIdData.data[j].user_email;
                      }
                    }
                  }
                  this.displayBulkDeckarationReport = tblData;
                }
                else {
                  this.displayBulkDeckarationReport = tblData;
                }
              }
              else if (fetchCustomerIdData.status != -114) {
                this.commonService.errorsmsg('Fetch Error: ' + fetchCustomerIdData.txt, "Error");
              }
              /*if (fetchTableDateValue.status == 0) {
                if (fetchTableDateValue.data.length > 0) {
                  for (var inner_i = 0; inner_i < tblData.length; inner_i++) {
                    let declaredDate = [];
                    let remainderDate = [];
                    for (var inner_j = 0; inner_j < fetchTableDateValue.data.length; inner_j++) {
                      if (tblData[inner_i].policy_no == fetchTableDateValue.data[inner_j].policy_no) {
                        let datesFor = fetchTableDateValue.data[inner_j].policyNoDeclarDates.split(",")
                        for (let count = 0; count < datesFor.length; count++) {
                          var index = declaredDate.indexOf(datesFor[count]);
                          if (index == -1)
                            declaredDate.push(datesFor[count]);
                        }
                        var index1 = remainderDate.indexOf(this.datePipe.transform(fetchTableDateValue.data[inner_j].mail_last_send_date, 'dd-MM-yyyy'));
                        if (index1 == -1)
                          remainderDate.push(this.datePipe.transform(fetchTableDateValue.data[inner_j].mail_last_send_date, 'dd-MM-yyyy'));
                      }
                    }
                    tblData[inner_i].declaration_pending_for = declaredDate.join(",");
                    if (remainderDate.length > 0)
                      tblData[inner_i].last_remainder_set_on = remainderDate.reduce(function (a, b) {
                        return new Date(a) > new Date(b) ? a : b;
                      }); else tblData[inner_i].last_remainder_set_on = "";
                    this.displayBulkDeckarationReport.push(tblData[inner_i]);
                  }
                }
                else {
                  this.displayBulkDeckarationReport = tblData;
                }
              }
              else if (fetchTableDateValue.status != -114) {
                this.commonService.errorsmsg('Fetch Error: ' + fetchTableDateValue.txt, "Error");
              }*/
           //}
         // }*/
        }
        else if (responseData.status != -114) {
          this.commonService.errorsmsg('Fetch Error: ' + responseData.txt, "Error");
        }
       /* for (let inner_idx = 0; inner_idx < this.displayBulkDeckarationReport.length; inner_idx++) {
          // if (this.displayBulkDeckarationReport[inner_idx].last_remainder_set_on != '') {
            //const formatDate = new Date((this.displayBulkDeckarationReport[inner_idx].last_remainder_set_on).split("-").reverse().join("-") + 'T00:00:00Z');
            //const fromDate = new Date(this.datePipe.transform(this.f.selectFromDate.value, 'yyyy-MM-dd') + 'T00:00:00Z');
            //const toDate = new Date(this.datePipe.transform(this.f.selectToDate.value, 'yyyy-MM-dd') + 'T00:00:00Z');
            // if (formatDate >= fromDate && formatDate <= toDate) {
              //this.displayBulkDeckarationReport[inner_idx].last_remainder_set_on = new Date(this.datePipe.transform(this.displayBulkDeckarationReport[inner_idx].last_remainder_set_on, 'dd-MM-yyyy'));
              this.displayFinalBulkDeckarationReport.push({
                'data': this.displayBulkDeckarationReport[inner_idx]
              })
            // }
          // }
        }*/
        this.dtTrigger.next();
        $('#divBulkDeclarationReportDataTable').show();
        $('#btnBulkDeclarationReportExcelDownload').show();
      }
    }
  }

  /*
   * Created By : Keerthana
   * Description : This function is used to download the excel file.
   *********************************************/

  exportExcel() {
    var tmpArray = [];
    var tmpObj = {};
    if (this.displayFinalBulkDeckarationReport.length > 0) {
      for (var i = 0; i < this.displayFinalBulkDeckarationReport.length; i++) {
        tmpObj = {};
        tmpObj['client_email'] = this.displayFinalBulkDeckarationReport[i].client_email;
        tmpObj['policy_no'] = this.displayFinalBulkDeckarationReport[i].policy_no;
        tmpObj['voyage_name'] = this.displayFinalBulkDeckarationReport[i].voyage_name;
        tmpObj['policy_type'] = this.displayFinalBulkDeckarationReport[i].policy_type;
        tmpObj['policy_expiry_date'] = this.displayFinalBulkDeckarationReport[i].policy_expiry_date;
        tmpObj['branch_location'] = this.displayFinalBulkDeckarationReport[i].branch_location;
        tmpObj['insured_name'] = this.displayFinalBulkDeckarationReport[i].insured_name;
        tmpObj['producer_name'] = this.displayFinalBulkDeckarationReport[i].producer_name;
        tmpObj['email'] = this.displayFinalBulkDeckarationReport[i].email;
        tmpObj['declaration_frequency'] = this.displayFinalBulkDeckarationReport[i].declaration_frequency;
        tmpObj['declaration_pending_for'] = this.displayFinalBulkDeckarationReport[i].declaration_pending_for;
        tmpObj['last_remainder_set_on'] = this.displayFinalBulkDeckarationReport[i].last_remainder_set_on;

        tmpArray.push(tmpObj)
      }
      var datajson = { datajson1: tmpArray };

      var Heading = [
        [],
        ["Bulk Declaration Report"],
        [],
        ["From Date", this.datePipe.transform(this.bulkDeclarationReportForm.value.selectFromDate, 'dd-MM-yyyy') || ''],
        ["To Date", this.datePipe.transform(this.bulkDeclarationReportForm.value.selectToDate, 'dd-MM-yyyy') || ''],
        [],
        ["Client User ID", "Policy No", "Voyage Name", "Policy Type", "Policy Expiry Date", "Branch Location", "Insured Name", "Producer Name", "Producer Email ID", "Declaration Frequency", "Declaration Pending For", "Last Reminder Sent On"]
      ];

      const merge = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 10 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 10 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 10 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 10 } },
        { s: { r: 6, c: 0 }, e: { r: 6, c: 10 } }
      ];

      var wscols = [];
      //let cell;
      for (let idx = 0; idx < Heading[6].length; idx++) {
        wscols.push({ wch: 30 });  // Common column width
      }
      var ws = XLSX.utils.json_to_sheet(Heading);
      ws['!cols'] = wscols;
      ws["!merges"] = merge;
      ws["A1"] = {
        "t": 's',
        /* "v": 'TATA MARINE', */
        "s": { font: { size: 20, bold: true, color: "#e012e0", style: "text-align:center" } }
      };
      XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
        header: ["client_email", "policy_no", "voyage_name", "policy_type", "policy_expiry_date", "branch_location", "insured_name", "producer_name", "email", "declaration_frequency", "declaration_pending_for", "last_remainder_set_on"],
        skipHeader: true,
        origin: -1
      });
      // var alphabets = [''];
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Bulk Declaration Report");
      XLSX.writeFile(wb, 'Bulk_Declaration_Report.xlsx');
    }
    else {
      this.commonService.errorsmsg("Unable to download excel,No data available in the table", "Error");
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will filter datatable according to search.
  *********************************************/

  filterBySearch() {
    let searchClientUserId = $("#searchClientUserId").val().toString().toLowerCase();
    let searchPolicyNo = $("#searchPolicyNo").val().toString().toLowerCase();
    let searchVoyageName = $("#searchVoyageName").val().toString().toLowerCase();
    let searchPolicyType = $("#searchPolicyType").val().toString().toLowerCase();
    let searchPolicyExpirtDate = $("#searchPolicyExpirtDate").val().toString().toLowerCase();
    let searchBranchLocation = $("#searchBranchLocation").val().toString().toLowerCase();
    let searchInsuredName = $("#searchInsuredName").val().toString().toLowerCase();
    let searchProducerName = $("#searchProducerName").val().toString().toLowerCase();
    let searchProducerEmailId = $("#searchProducerEmailId").val().toString().toLowerCase();
    let searchDeclarationFrequency = $("#searchDeclarationFrequency").val().toString().toLowerCase();
    let searchDeclarationPendingFor = $("#searchDeclarationPendingFor").val().toString().toLowerCase();
    let lastRemindSentOn = $("#lastRemindSentOn").val().toString().toLowerCase();

    let table = $("#bulkDeclarationReportDataTable").DataTable();
    table.search('').columns().search('').draw();
    if (searchClientUserId != "") {
      table.column(0).search(searchClientUserId).draw();
    }
    if (searchPolicyNo != "") {
      table.column(1).search(searchPolicyNo).draw();
    }
    if (searchVoyageName != "") {
      table.column(2).search(searchVoyageName).draw();
    }
    if (searchPolicyType != "") {
      table.column(3).search(searchPolicyType).draw();
    }
    if (searchPolicyExpirtDate != "") {
      table.column(4).search(searchPolicyExpirtDate).draw();
    }
    if (searchBranchLocation != "") {
      table.column(5).search(searchBranchLocation).draw();
    }
    if (searchInsuredName != "") {
      table.column(6).search(searchInsuredName).draw();
    }
    if (searchProducerName != "") {
      table.column(7).search(searchProducerName).draw();
    }
    if (searchProducerEmailId != "") {
      table.column(8).search(searchProducerEmailId).draw();
    }
    if (searchDeclarationFrequency != "") {
      table.column(9).search(searchDeclarationFrequency).draw();
    }
    if (searchDeclarationPendingFor != "") {
      table.column(10).search(searchDeclarationPendingFor).draw();
    }
    if (lastRemindSentOn != "") {
      table.column(11).search(lastRemindSentOn).draw();
    }
  }

}


